export default "/images/vendor/flag-icon-css/flags/1x1/eg.svg?c6ff8d6c3057865a32f17e347d1916dd";